import { Component, inject } from '@angular/core';
import { UserService } from '../../../../shared/services/user.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { take } from 'rxjs';
import { CONFIG } from '../../../../../../config.token';
import { CwComponentsModule } from '../../../../shared/components/components.module';

@Component({
    selector: 'zp-toolbar-user-menu',
    templateUrl: './toolbar-user-menu.component.html',
    styleUrls: [
        './toolbar-user-menu.component.scss'
    ],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        CwComponentsModule
    ]
})
export class ToolbarUserMenuComponent {

    public isLoaderShown = false;

    private userService = inject(UserService);
    private config = inject(CONFIG);

    public logout(): void {
        this.isLoaderShown = true;
        this.userService.signOut()
            .pipe(take(1))
            .subscribe({
                next: () => {
                    location.href = this.config.LOGIN_URL;
                },
                error: () => {
                    this.isLoaderShown = false;
                }
            });
    }

}
